import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalAccountsService } from "services/ClientPortalAccountsService";
import { PLClientTransactionModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  ClientTransactions: new PLClientTransactionModel(),
  Loading: false,
};

export const ClientTransactionsTableSlice = createSlice({
  name: "ClientTransactionsTable",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllTransactionsForClient.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getAllTransactionsForClient.fulfilled, (state, action) => {
        state.ClientTransactions = action.payload;
        state.Loading = false;
      })
      .addCase(getAllTransactionsForClient.rejected, (state) => {
        state.ClientTransactions = new PLClientTransactionModel();
        state.Loading = false;
      })
      .addCase(downloadClientInvoicePDF.pending, (state) => {
        state.Loading = true;
      })
      .addCase(downloadClientInvoicePDF.fulfilled, (state) => {
        state.Loading = false;
      })
      .addCase(downloadClientInvoicePDF.rejected, (state) => {
        state.Loading = false;
      });
  },
});

export const getAllTransactionsForClient = createAsyncThunk<PLClientTransactionModel, { clientID: string }>(
  "ClientTransactionsTable/getAllTransactionsForClient",
  async ({ clientID }) => {
    const accountsService = container.get<IClientPortalAccountsService>(SERVICE_TYPES.ClientPortalAccountsService);
    return await accountsService.getAllTransactionsForClient(clientID);
  }
);

export const downloadClientInvoicePDF = createAsyncThunk(
  "ClientTransactionsTable/downloadClientInvoicePDF",
  async (plClientTransactionFileID: string) => {
    const accountsService = container.get<IClientPortalAccountsService>(SERVICE_TYPES.ClientPortalAccountsService);
    return await accountsService.downloadClientInvoicePDF(plClientTransactionFileID);
  }
);

export const selectClientTransactions = (state: RootState) => {
  return state.clientTransactionsTable.ClientTransactions;
};

export const selectLoadingClientTransactions = (state: RootState) => {
  return state.clientTransactionsTable.Loading;
};

export default ClientTransactionsTableSlice.reducer;
